/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  getDate.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:37
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 引入 moment 时间插件
 * name：张少敏
 * date:2021.11.11
 */
import moment from "moment";
//获取今日/昨日/本周/上周/本月/上月 时间
// 新增获取近7日/本季度/上季度/本年/去年
export default {
  // 获取今日的开始结束时间
  getToday () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().startOf("day").valueOf()).format("YYYY-MM-DD");
    obj.endtime = moment(moment().valueOf()).format("YYYY-MM-DD");
    return obj
  },
  // 获取昨日的开始结束时间
  getYesterday () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().add(-1, 'days').startOf("day").valueOf()).format("YYYY-MM-DD");
    obj.endtime = moment(moment().add(-1, 'days').endOf('day').valueOf()).format('YYYY-MM-DD');
    return obj
  },
  // 获取当前周的开始结束时间
  getCurrWeekDays () {
    let obj = {
      starttime: '',
      endtime: '',
      starttimes: ''
    }
    obj.starttime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD')
    obj.endtime = moment(moment().week(moment().week()).endOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
    obj.starttimes = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('MM-DD')
    return obj
  },
  // 获取上一周的开始结束时间
  getLastWeekDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().week(moment().week() - 1).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD')
    obj.endtime = moment(moment().week(moment().week() - 1).endOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
    return obj
  },
  // 获取当前月的开始结束时间
  getCurrMonthDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().month(moment().month()).startOf('month').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().month(moment().month()).endOf('month').valueOf()).format('YYYY-MM-DD');
    return obj
  },
  // 获取上一个月的开始结束时间
  getLastMonthDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().month(moment().month() - 1).startOf('month').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().month(moment().month() - 1).endOf('month').valueOf()).format('YYYY-MM-DD');
    return obj
  },

  // 获取近7日的开始结束时间
  getLastSevenDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().add(-7, 'days').startOf("day").valueOf()).format("YYYY-MM-DD");
    obj.endtime = moment(moment().endOf('day').valueOf()).format('YYYY-MM-DD');
    return obj
  },

  // 获取本季度的开始结束时间
  getCurrQuarterDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().quarter(moment().quarter()).startOf('quarter').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().quarter(moment().quarter()).endOf('quarter').valueOf()).format('YYYY-MM-DD');
    return obj
  },
  // 获取上季度的开始结束时间
  getLastQuarterDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().quarter(moment().quarter() - 1).startOf('quarter').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().quarter(moment().quarter() - 1).endOf('quarter').valueOf()).format('YYYY-MM-DD');
    return obj
  },

  // 获取本年的开始结束时间
  getCurrYearDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().year(moment().year()).startOf('year').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().year(moment().year()).endOf('year').valueOf()).format('YYYY-MM-DD');
    return obj
  },
  // 获取去年的开始结束时间
  getLastYearDays () {
    let obj = {
      starttime: '',
      endtime: ''
    }
    obj.starttime = moment(moment().year(moment().year() - 1).startOf('year').valueOf()).format('YYYY-MM-DD');
    obj.endtime = moment(moment().year(moment().year() - 1).endOf('year').valueOf()).format('YYYY-MM-DD');
    return obj
  },

}
